<template>
  <nav v-if="user" class="banner">
    <banner-left />
    <banner-right />
  </nav>
</template>

<script>
import BannerLeft from "./BannerLeft";
import BannerRight from "./BannerRight";
import { mapState } from "vuex";

export default {
  name: "banner",

  components: {
    BannerLeft,
    BannerRight
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    }),

    user() {
      return this.auth.user;
    }
  }
};
</script>

<style lang="sass" scoped>
.banner
  width: 100%
  display: flex
  justify-content: space-between
  background: darken($dark-purple, 5%)

  .banner-right
      margin: auto 30px auto auto
</style>